/** Proposal display rules shared by the chat card and the Proposals page. */
import type { ProposalKind } from '../../../supabase/functions/_shared/assistant/cards.ts';
import type { Language, MessageKey } from './i18n.ts';
import { formatAed } from './format.ts';

/** Everything a proposal view needs from the row: figures, status, how it was approved. */
export const PROPOSAL_COLUMNS =
  'id, kind, status, title, summary, rationale, plan, daily_change_fils, month_change_fils, projected_month_fils, monthly_cap_fils, auto_approved_stage, cancel_reason, expires_at, created_at';

export const KIND_KEYS: Record<ProposalKind, MessageKey> = {
  launch: 'kindLaunch',
  budget_change: 'kindBudgetChange',
  pause: 'kindPause',
  resume: 'kindResume',
  creative_update: 'kindCreativeUpdate',
  negative_keywords: 'kindNegativeKeywords',
  language_change: 'kindLanguageChange',
};

export const STATUS_KEYS: Record<string, MessageKey> = {
  pending: 'propPending',
  approved: 'propApproved',
  applying: 'propApplying',
  rejected: 'propRejected',
  expired: 'propExpired',
  applied: 'propApplied',
  failed: 'propFailed',
  superseded: 'propSuperseded',
  cancelled: 'propCancelled',
};

export const CANCEL_KEYS: Record<string, MessageKey> = {
  emergency_stop: 'cancelEmergency',
  trust_stage_lowered: 'cancelStageLowered',
  owner_withdrew: 'cancelOwnerWithdrew',
};

/** What the owner reads when a decision is refused, by the database's error code. */
export function decideErrorKey(code: string | undefined): MessageKey {
  switch (code) {
    case 'AS001':
      return 'decideOverCap';
    case 'AS002':
      return 'decideCapNotSet';
    case 'AS004':
      return 'decideBranchNotCleared';
    default:
      return 'decideFailed';
  }
}

/** An amount with its sign ("+50 درهم", "−20 درهم", "0 درهم"). */
export function formatAedChange(fils: number, language: Language): string {
  const amount = formatAed(Math.abs(fils), language);
  return fils > 0 ? `+${amount}` : fils < 0 ? `−${amount}` : amount;
}
